import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import Layout from '@/components/Layout';
import { useEffect, useState } from 'react';
import SelectInput from '@/components/Input/SelectInput';
import Card from '@/components/Card';
import { useTheme } from '@mui/material';
import api from '@/services/api';
import { enqueueSnackbar } from 'notistack';
import { HeaderStack, NoDataStack, ReportsStack } from './styles';

function Reports() {
  const { t } = useTranslation();
  const theme = useTheme();

  const [reportList, setReportList] = useState<ReportsType[]>([]);
  const [selectedReport, setSelectedReport] = useState<ReportsType | null>(
    null
  );

  const [loading, setLoading] = useState(true);

  // Fetch reports on component mount
  useEffect(() => {
    const fetchReports = async () => {
      try {
        setLoading(true);

        const response = await api.get('/reports');

        setReportList(response.data);
      } catch {
        enqueueSnackbar(t('config.reports.fetchError'), { variant: 'error' });
      } finally {
        setLoading(false);
      }
    };

    fetchReports();
  }, []);

  return (
    <Layout noLeftMargin>
      <ReportsStack>
        {/** Header with report selection */}
        <HeaderStack>
          <Typography variant="h5">{t('reports.title')}</Typography>
          <SelectInput
            width="300px"
            options={reportList.map((r) => r.description)}
            value={selectedReport?.description ?? ''}
            onChange={(e) =>
              setSelectedReport(
                reportList.find((r) => r.description === e.target.value) ?? null
              )
            }
          />
        </HeaderStack>

        {/** Report display */}
        <Card sx={{ width: '100%', height: '90vh' }}>
          {selectedReport ? (
            <iframe
              title={selectedReport.description}
              src={selectedReport.url}
              style={{ width: '100%', height: '100%', border: 'none' }}
            />
          ) : (
            <NoDataStack>
              <Typography variant="h6" color={theme.palette.grey['01']}>
                {t('reports.noData')}
              </Typography>
            </NoDataStack>
          )}
        </Card>
      </ReportsStack>
    </Layout>
  );
}

export default Reports;
